/**
 * /tenants/$slug/getting-started — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchSetupStatus } from "@/features/getting-started/queries";
import { queryKeys } from "@/lib/query-keys";
import { GettingStartedPage } from "@/features/getting-started/pages/getting-started-page";

export const Route = createFileRoute("/_authed/tenants/$slug/getting-started/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.gettingStarted(context.tenant.id),
      queryFn: () => fetchSetupStatus(context.tenant.id),
    }),
  component: GettingStartedPage,
});
